import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsThisFor() {
  const forWho = ['Mujeres que trabajan fuera o dentro de casa y llegan agotadas al final del día.', 'Madres que sienten que el orden de la casa es una batalla perdida contra el tiempo.', 'Personas que sufren de ansiedad ante el caos visual pero no saben por dónde empezar.', 'Dueñas de casa que quieren recuperar sus fines de semana y dejar de limpiar los sábados.'];
  const notForWho = ['Personas que buscan guías de limpieza profunda de 4 horas.', 'Quienes prefieren sistemas complejos de organización con etiquetas y carpetas.', 'Aquellos que no están dispuestos a cambiar el "lo hago luego" por la "regla de 2 minutos".'];
  return <section className="py-24 bg-white" data-id="element-125">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-126">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-127">
          <FadeIn data-id="element-128">
            <div className="bg-linen p-8 md:p-10 rounded-2xl h-full border-t-4 border-terracotta" data-id="element-129">
              <h3 className="text-2xl md:text-3xl font-serif text-charcoal mb-8 flex items-center" data-id="element-130">
                <span className="bg-terracotta text-white rounded-full p-1 mr-3" data-id="element-131">
                  <Check size={20} strokeWidth={3} data-id="element-132" />
                </span>
                Esto SÍ es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-133">
                {forWho.map((text, i) => <li key={i} className="flex items-start" data-id="element-134">
                    <Check className="text-terracotta shrink-0 mt-1 mr-3" size={20} data-id="element-135" />
                    <span className="text-charcoal leading-relaxed" data-id="element-136">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-137">
            <div className="bg-gray-50 p-8 md:p-10 rounded-2xl h-full border-t-4 border-warmgray" data-id="element-138">
              <h3 className="text-2xl md:text-3xl font-serif text-charcoal mb-8 flex items-center" data-id="element-139">
                <span className="bg-warmgray text-white rounded-full p-1 mr-3" data-id="element-140">
                  <X size={20} strokeWidth={3} data-id="element-141" />
                </span>
                Esto NO es para ti si...
              </h3>
              <ul className="space-y-6" data-id="element-142">
                {notForWho.map((text, i) => <li key={i} className="flex items-start" data-id="element-143">
                    <X className="text-warmgray shrink-0 mt-1 mr-3" size={20} data-id="element-144" />
                    <span className="text-warmgray leading-relaxed" data-id="element-145">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}